import { IApplicationState } from '../../types/redux';

export const selectUnfinishedAnketaModalNewAnketaUrl = (state: IApplicationState): string | null =>
  state.calculator.unfinishedAnketaModal.newAnketaUrl;
